import React from 'react'
import ModalContent from './ModalContent';
import { useStateContext } from '../context/StateContext';
import { urlFor } from '../lib/client';

const HorizontalSwipe = ({images}) => {
    const{modalOpen, setModalOpen, setModalContent} = useStateContext();

    const modalContent = (item, index) =>    
    <ModalContent 
    setOpenModal={setModalOpen}
    setModalContent={setModalContent}
    title={"Picture Modal"}
    body={`Picture ${index}`}
    continueTo={()=>{
        //console.log("continue from parent")
    }}
    fullImage={item}
    />

    
  return (
<div className='horizontal-swipe-wrapper'>
        {!Array.isArray(images) ? [] : images?.map?.((item, index) => { 
            const key = index
            //const url = urlFor(item && item).width(1020).height(1020)?.url()
            const base64 = item?.src
            const onPicClick = () => {
                //setModalContent(modalContent(item, index))
                //setModalOpen(!modalOpen);
                //console.log("modal clicked")
            }
            return(
            <div key={key} onClick={()=>onPicClick()} className='horizontal-swipe-box'>
                {base64 && <img 
                    src={base64}
                    //width={1020}
                    //height={1020}
                    style={{width:"120px", height:"120px"}}
                    className="product-image"
                />}
            </div>
        )})}
        
    </div>
  )
}

export default HorizontalSwipe

/*

const HorizontalSwipe = ({images}) => {
  


  return (

    <div className='horizontal-swipe-wrapper'>
        {images.map?.((item, index) => { 
        
            const onPicClick = () => {
                setModalContent(modalContent(item, index))
                setModalOpen(!modalOpen);
                //console.log("modal clicked")
            }
            return(
            <div onClick={()=>onPicClick()} className='horizontal-swipe-box'>
                <img 
                    src={urlFor(item && item).width(120).height(120).fit("fillmax")}
                    className="product-image"
                />
            </div>
        )})}
    </div>

  )
}

*/